import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, ShoppingCart, ChevronRight, Search } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function MobilePurchaseOrdersPage() {
  const navigate = useNavigate();
  const [pos, setPos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    axios.get(`${API}/warehouse/purchase-orders`).then(r => setPos(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = pos.filter(p => !search || (p.po_number || '').toLowerCase().includes(search.toLowerCase()) || (p.vendor_name || p.supplier || '').toLowerCase().includes(search.toLowerCase()));

  if (loading) return <div className="mobile-page"><div className="mobile-loading"><div className="mobile-spinner" /></div></div>;

  return (
    <div className="mobile-page">
      <button className="mobile-back-btn" onClick={() => navigate('/mobile/more')}><ArrowLeft size={18} /> More</button>
      <div className="mobile-page-title" style={{ marginBottom: 12 }}>Purchase Orders</div>
      <div style={{ position: 'relative', marginBottom: 14 }}>
        <Search size={16} style={{ position: 'absolute', left: 12, top: 13, color: '#8e8e93' }} />
        <input className="mobile-input" placeholder="Search POs..." value={search} onChange={e => setSearch(e.target.value)} style={{ paddingLeft: 36 }} />
      </div>
      <div className="mobile-kpi-row" style={{ marginBottom: 14 }}>
        <div className="mobile-kpi-card blue"><div className="mobile-kpi-label">Total POs</div><div className="mobile-kpi-value">{pos.length}</div></div>
        <div className="mobile-kpi-card green"><div className="mobile-kpi-label">Open</div><div className="mobile-kpi-value">{pos.filter(p => p.status === 'open' || p.status === 'pending').length}</div></div>
      </div>
      {filtered.length === 0 ? <div className="mobile-empty-state"><ShoppingCart /><p>No purchase orders found</p></div> : (
        <div className="mobile-menu-list">
          {filtered.map(po => (
            <button key={po.po_id} className="mobile-menu-item" onClick={() => navigate(`/mobile/purchase-orders/${po.po_id}`)}>
              <div className="mobile-menu-item-icon" style={{ background: po.status === 'received' ? '#34c759' : '#007aff' }}><ShoppingCart size={16} /></div>
              <div className="mobile-menu-item-content">
                <div className="mobile-menu-item-title">{po.po_number}</div>
                <div className="mobile-menu-item-subtitle">{po.vendor_name || po.supplier || 'N/A'} · {po.status || 'open'} · {po.line_items?.length || 0} items</div>
              </div>
              <ChevronRight size={16} className="mobile-menu-item-chevron" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
